import styled from 'styled-components';

const StyledMainContainer = styled.div`
	width: 100%;
	height: 960px;
`;

const StyledContainer = styled.div`
	height: 100%;
`;

export { StyledContainer, StyledMainContainer };
